// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-js": () => import("/zeit/77b215bd/src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-contact-js": () => import("/zeit/77b215bd/src/templates/contact.js" /* webpackChunkName: "component---src-templates-contact-js" */),
  "component---src-templates-home-js": () => import("/zeit/77b215bd/src/templates/home.js" /* webpackChunkName: "component---src-templates-home-js" */),
  "component---src-templates-post-js": () => import("/zeit/77b215bd/src/templates/post.js" /* webpackChunkName: "component---src-templates-post-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/zeit/77b215bd/.cache/data.json")

